exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".details-iframe{width:100%}.iframe-view{position:relative;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/src/views/IframeView.css
// module id = 1991
// module chunks = 0